"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _objectSpread2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _buildingSevice = require("@/api/building-sevice.api");
var rule = {
  required: true,
  message: "Bắt buộc",
  trigger: "submit"
};
var BuildingServiceModal = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(BuildingServiceModal, _Vue);
  var _super = (0, _createSuper2.default)(BuildingServiceModal);
  function BuildingServiceModal() {
    var _this;
    (0, _classCallCheck2.default)(this, BuildingServiceModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildingId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "visible", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "form", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rules", {
      // price: rule,
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", false);
    return _this;
  }
  (0, _createClass2.default)(BuildingServiceModal, [{
    key: "onSubmitOk",
    value: function onSubmitOk() {
      return "";
    }
  }, {
    key: "dataSubmit",
    get: function get() {
      return {
        service: this.form
      };
    }
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var data, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$refs.form.validate();
              case 2:
                this.loading = true;
                _context.prev = 3;
                data = {
                  buildingServices: [this.form],
                  buildingId: this.buildingId
                };
                _context.next = 7;
                return _buildingSevice.buildingServiceApi.create(data);
              case 7:
                res = _context.sent;
                this.$notify({
                  title: "Thông báo",
                  message: "Cập nhật thành công",
                  type: "success"
                });
                this.visible = false;
                this.onSubmitOk();
              case 11:
                _context.prev = 11;
                this.loading = false;
                return _context.finish(11);
              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3,, 11, 14]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleUpdate",
    value: function handleUpdate(data) {
      this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data.buildingService), {}, {
        serviceId: data.id
      });
      this.visible = true;
    }
  }]);
  return BuildingServiceModal;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], BuildingServiceModal.prototype, "buildingId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Emit)("submit:ok")], BuildingServiceModal.prototype, "onSubmitOk", null);
BuildingServiceModal = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], BuildingServiceModal);
var _default = BuildingServiceModal;
exports.default = _default;